const MOSCOW_TZ = "Europe/Moscow";

export function getMoscowHour(date: Date): number {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: MOSCOW_TZ,
    hour: "numeric",
    hour12: false,
  }).formatToParts(date);
  return Number(parts.find((p) => p.type === "hour")?.value ?? 0);
}

/** Тихие часы 22:00–09:00 по Москве. */
export function isMoscowQuietHours(date: Date): boolean {
  const hour = getMoscowHour(date);
  return hour >= 22 || hour < 9;
}

export const QUIET_HOURS_ERROR =
  "Сейчас тихие часы 22:00–09:00 МСК. Отправка не поставлена в очередь.";
